export const s2ms = (s) => {
    return s*1000;
}

export const m2ms = (m) => {
    return m*60*1000;
}